import * as React from 'react';
import type { MutableRefObject } from 'react';

import { languageCodeToName } from 'js/lib/language';

import { Typography2 } from '@coursera/cds-core';
import type { Source } from '@coursera/event-pulse-types';
import { useVisibilityTracker } from '@coursera/event-pulse/react';

import _t from 'i18n!nls/xdp';

type Props = {
  userLanguageForAiDubbing: string;
  langSource: Source;
};

const TrackedHeroLanguageLabel = (props: Props) => {
  const { userLanguageForAiDubbing, langSource } = props;

  const visibilityTrackingRef: MutableRefObject<HTMLDivElement | null> = useVisibilityTracker(
    'view_hero_language_info',
    {
      source: langSource,
      language: userLanguageForAiDubbing,
    }
  );
  return (
    <Typography2 component="p" variant="bodyPrimary" ref={visibilityTrackingRef}>
      {_t('Taught in #{language} (AI Dubbing)', {
        language: languageCodeToName(userLanguageForAiDubbing),
      })}
    </Typography2>
  );
};

export { TrackedHeroLanguageLabel };
